import React from 'react';
import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';
import { PropTypes } from 'prop-types';
import { Button } from 'components';
import { useAuthStore } from 'stores/authStore';
import { LuLogOut } from 'react-icons/lu';
const compactStyles = css`
  margin-bottom: 0;
  padding: 10px 12px;
`;

const InfoBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px 16px;
  margin-bottom: 20px;
  border-left: 3px solid #be1622;
  background: #f8fafb;
  border-radius: 0 6px 6px 0;

  ${({ $compact }) => $compact && compactStyles}
`;

const InfoRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: 8px;
  font-size: 13px;
`;

const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const InfoLabel = styled.span`
  color: #65757d;
  min-width: 56px;
  flex-shrink: 0;
`;

const InfoValue = styled.span`
  color: #1a2b33;
  font-weight: bold;
  word-break: break-word;
`;

const OnboardingCreatorInfoBlock = ({ compact = false, onLogout }) => {
  const { t } = useTranslation(['pages']);
  const user = useAuthStore((state) => state.user);

  const fullName = [user?.name, user?.last_name].filter(Boolean).join(' ').trim();
  const email = user?.email;

  if (!fullName && !email) {
    return null;
  }

  return (
    <InfoBlock $compact={compact}>
      <HeaderRow>
        <Content>
          <InfoRow>
            <InfoLabel>{t('activateAccount.name')}</InfoLabel>
            <InfoValue>{fullName || '-'}</InfoValue>
          </InfoRow>
          <InfoRow>
            <InfoLabel>{t('activateAccount.email')}</InfoLabel>
            <InfoValue>{email || '-'}</InfoValue>
          </InfoRow>
        </Content>
        {onLogout && (
          <Button
            variant="primary"
            onClick={onLogout}
            style={{
              width: '34px',
              height: '34px',
              borderRadius: '50%',
              padding: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}
            aria-label={t('onboarding.logout')}
            title={t('onboarding.logout')}
          >
            <LuLogOut size={16} style={{ padding: 0 }} aria-hidden="true" />
          </Button>
        )}
      </HeaderRow>
    </InfoBlock>
  );
};

OnboardingCreatorInfoBlock.propTypes = {
  compact: PropTypes.bool,
  onLogout: PropTypes.func,
};

export default OnboardingCreatorInfoBlock;
